/**
 * Minimal, dependency-free `className` joiner.
 *
 * Accepts strings, arrays, and falsy values (skipped) so components can compose
 * conditional Tailwind classes without pulling in `clsx`/`classnames`. Kept in
 * `@richrich/ui` so both primitives and chart chrome share one implementation.
 */
export type ClassValue = string | number | false | null | undefined | ClassValue[];

export function cn(...values: ClassValue[]): string {
  const out: string[] = [];
  for (const v of values) {
    if (v === false || v === null || v === undefined || v === "") continue;
    if (Array.isArray(v)) {
      const nested = cn(...v);
      if (nested) out.push(nested);
      continue;
    }
    out.push(String(v));
  }
  return out.join(" ");
}
